export const ShopSettingsHomepageBannerForm = {
  model: 'Supplier',
  format: [
    {
      widths: 'equal',
      fields: {
        logo: {
          type: 'file',
          modelOverride: 'Business',
          label: 'Business Homepage Banner',
        },
      },
    },
  ],
}
